<div class="d-flex flex-column align-items-stretch wrapper position-relative" #fileUploaderRef>
    <div class="d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom" *ngIf="label || icon">
        <div class="d-flex align-items-center">
            <i class="icon {{icon}} me-2" *ngIf="icon"></i>
            <div *ngIf="label" class="color-greyish">{{label | translate}}</div>
        </div>
        <div class="d-flex align-items-center cursor-pointer z-2" (click)="onSelectFileClick()" *ngIf="!readonly">
            <i class="icon icon-16-px-mas color-primary"></i>
            <span class="color-primary">{{'FILEUPLOADER.PLACEHOLDER' | translate}}</span>
        </div>
    </div>
    <div class="d-flex flex-column">
        <div *ngIf="files?.length > 0" class="file-box">
            <div class="d-flex justify-content-between align-items-center z-front w-100"
                *ngFor="let file of files;let i = index">
                <div class="d-flex align-items-center w-100 mb-3">
                    <div class="ml-right w-50 d-flex cursor-pointer" (click)="onDownloadClick(file)">
                        <span class="icon font-xxxlarge" [ngClass]="getIcon(file?.name || file?.txtNam)"></span>
                        <span class="font-large mr-6 ellipsis-100">{{file?.name || file?.txtNam}}</span>
                    </div>
                    <div class="ms-auto d-flex w-50">
                        <mapfre-auditlib-input *ngIf="showComment" [(model)]="file.comment"
                            [placeholder]="'WORKS.CREATE.STEP2.FILE_PLACEHOLDER' | translate" styleClass="w-100">
                        </mapfre-auditlib-input>

                        <button class="ms-3 no-styles cursor-pointer ms-auto" *ngIf="!readonly"
                            (click)="onDeleteClick(file)">
                            <i *ngIf="file?.name" class="icon icon-16-px-cancelar"></i>
                            <i *ngIf="!file?.name && allowDelete" class="icon icon-24-px-eliminar"></i>
                        </button>
                        <button class="ms-3 no-styles cursor-pointer" [ngClass]="{'ms-auto':readonly}"
                            (click)="onDownloadClick(file)" *ngIf="!file?.name">
                            <i class="icon icon-24-px-descarga font-xxxlarge mr-6 cursor-pointer"></i>
                        </button>
                    </div>
                </div>
                <!--<div class="d-flex align-items-center">
                    <i class="pi pi-file font-xxxlarge opacity-7 mr-6"></i>
                    <span class="font-large mr-6" *ngIf="file.name">{{file.name | slice: '15' }}</span>
                    <span class="font-large mr-6" *ngIf="!file.name">{{ file }}</span>
                </div>
                <div class="d-flex align-items-center">
                    <i class="icon icon-24-px-descarga font-xxxlarge mr-6 cursor-pointer" *ngIf="!file.name"
                        (click)="onDownloadClick(file)"></i>
                    <i class="icon icon-24-px-eliminar font-xxxlarge cursor-pointer" (click)="onDeleteClick(file)"></i>
                </div>-->
            </div>
        </div>
        <div class="drag-box" *ngIf="!readonly" (click)="onSelectFileClick()">
            {{'FILEUPLOADER.PLACEHOLDER' | translate}}
        </div>
        <div class="drag-box-empty" *ngIf="readonly && files?.length === 0">
            {{'FILEUPLOADER.EMPTY' | translate}}
        </div>
    </div>
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="fileUploaderRef"></mapfre-auditlib-form-errors>
    <input type="file" (change)="onInputChange($event)" #inputFile *ngIf="!multiple && !readonly" />
    <input type="file" (change)="onInputChange($event)" #inputFile *ngIf="multiple && !readonly" multiple />
</div>